module.exports = __webpack_public_path__ + "static/media/floor-bokeh-2.fd5d12a9.png";